export default {
    '哪吒爱动智慧体育平台':'Nezha Aidong Smart Sports Platform',
    '登录鉴权中':'Logging in and authenticating, please wait...',
    '登录':'Login',
    '爱动力科技':'Aidongli Technology',
    '退出登录':'Log out',
    '个人中心':'Personal Center',
    '简体中文':'简体中文',
    '繁體中文':'繁體中文',
    '英语':'English',
    // 2025.3.19
    '新密码':'New password',
    '请输入新密码':'Please enter the new password',
    '确认新密码':'Confirm the new password',
    '请再次输入新密码以确认':'Please enter the new password again to confirm',
    '新密码不能少于6位':'The new password cannot be less than 6 digits',
    '请填写新密码':'Please fill in the new password',
    '账号密码格式仅支持大小写字母、数字及特殊符号':'The account password format only supports uppercase and lowercase letters, numbers, and special symbols',
    '新密码不能多于20位':'The new password cannot be more than 20 digits',
    '请确认新密码':'Please confirm the new password',
    '新账号密码长度至少为6位':'The new account password must be at least 6 digits long',
    '确认密码与新密码不一致!':'The confirmed password does not match the new password!',
    '重置密码成功':'Password reset successfully',

    // 2025.12.19
    '密码至少8位，需要包含英文+数字':'The password must be at least 8 characters long and contain both English letters and numbers',
}    